import { render, staticRenderFns } from "./UserProviderFilter.vue?vue&type=template&id=c9145a90&scoped=true"
import script from "./UserProviderFilter.vue?vue&type=script&lang=js"
export * from "./UserProviderFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9145a90",
  null
  
)

export default component.exports